import request from "@/utils/request";

// 分页查询
export function postProjectTable(data) {
  return request({
    url: "/project/table",
    method: "post",
    data,
  });
}

// 根据id获取详情
export function getProjectById(id) {
  return request({
    url: `/project/${id}`,
    method: "get",
  });
}

// 接收
export function postConfirmProject(data) {
  return request({
    url: "/project/confirm",
    method: "post",
    data,
  });
}

// 不予接收
export function postReturnProject(data) {
  return request({
    url: "/project/return",
    method: "post",
    data,
  });
}

// 获取审核详情
export function getProjectApproval(id) {
  return request({
    url: `/project/approval/${id}`,
    method: "get",
  });
}
